<nw-key-topic-two class="press__container" (mousedown)="goTo($event)">
    <div role="body">
        <div class="press__container__body"><ng-content></ng-content></div>
        <div class="press__container__content margin-top-xl">
            <h6>{{ heading }}</h6>
            <nw-icon class="press__container__content__quote-icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill
                    viewBox="0 0 24 24"
                    height="auto"
                    width="40px"
                    style="display: block"
                    preserveAspectRatio="xMidYMid meet"
                    focusable="false"
                >
                    <path
                        fill="currentColor"
                        d="M22.5 13.875a5.623 5.623 0 0 1-5.625 5.625H16.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h.375a2.627 2.627 0 0 0 2.625-2.625V13.5h-3c-1.655 0-3-1.345-3-3v-3c0-1.655 1.345-3 3-3h3c1.655 0 3 1.345 3 3v6.375Zm-12 0A5.623 5.623 0 0 1 4.875 19.5H4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h.375A2.627 2.627 0 0 0 7.5 13.875V13.5h-3c-1.655 0-3-1.345-3-3v-3c0-1.655 1.345-3 3-3h3c1.655 0 3 1.345 3 3v6.375Z"
                    />
                </svg>
            </nw-icon>
            <p class="press__container__content__name">
                {{ article }}
            </p>
            @if (paywall) {
                <div class="press__container__content__paywall">
                    <nw-icon
                        ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                d="M12 24c6.628 0 12-5.372 12-12S18.628 0 12 0 0 5.372 0 12s5.372 12 12 12Zm-1.875-8.25h1.125v-3h-1.125A1.122 1.122 0 0 1 9 11.625c0-.623.502-1.125 1.125-1.125h2.25c.623 0 1.125.502 1.125 1.125v4.125h.375c.623 0 1.125.502 1.125 1.125S14.498 18 13.875 18h-3.75A1.122 1.122 0 0 1 9 16.875c0-.623.502-1.125 1.125-1.125ZM12 9c-.83 0-1.5-.67-1.5-1.5S11.17 6 12 6s1.5.67 1.5 1.5S12.83 9 12 9Z"
                            />
                        </svg>
                    </nw-icon>
                    <p>Article behind paywall</p>
                </div>
            }
            @if (logo) {
                <img
                    class="press__container__content__logo margin-top-xl"
                    [ngSrc]="logo | sanitizeUrl"
                    alt="Press logo"
                    width="200"
                    height="20"
                />
            }
        </div>
    </div>
</nw-key-topic-two>
